module.exports = __webpack_public_path__ + "static/media/ap-header.0b55ef35.png";